import { render, staticRenderFns } from "./AufgabenTemplatedPagePers.vue?vue&type=template&id=31fd170f"
import script from "./AufgabenTemplatedPagePers.vue?vue&type=script&lang=ts"
export * from "./AufgabenTemplatedPagePers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports